import { render, staticRenderFns } from "./register.view.vue?vue&type=template&id=0d7b0504&scoped=true"
import script from "./register.view.vue?vue&type=script&lang=js"
export * from "./register.view.vue?vue&type=script&lang=js"
import style0 from "./register.view.vue?vue&type=style&index=0&id=0d7b0504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7b0504",
  null
  
)

export default component.exports